export default __webpack_public_path__ + "static/media/red_7_lightsalmonpink_diamond_fire_closed_straight_barrel.cf11c51b.png";